import { render } from "./bookmarkListItem.vue?vue&type=template&id=0375cbed&scoped=true"
import script from "./bookmarkListItem.vue?vue&type=script&lang=js"
export * from "./bookmarkListItem.vue?vue&type=script&lang=js"

import "./bookmarkListItem.vue?vue&type=style&index=0&id=0375cbed&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0375cbed"

export default script